export default {"src":"/_next/static/media/policy-design.e0fbb4a1.svg","height":792,"width":594,"blurWidth":0,"blurHeight":0};